// @flow
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withHelmet } from 'infrastructure/seo/Helmet';
import { dynamicClassName } from 'utils/dynamicClassName';
import type { TeamList } from 'types/TeamList';
import type { BlocContent } from 'types/NewsletterBloc';
import type { JoueurType, JoueurFiltersSearchType } from 'types/Joueur';
import { nullPlayersFiltersSearch } from 'types/Joueur';
import type { Status } from 'types/Status';
import type { SeasonListType } from 'types/Seasons';
import { convertObjectToQueryString, convertQueryStringToTeam } from 'utils/urlUtils';
import { objectFilterTitle } from 'utils/filterUtils';

import { STATUS_LOADING, STATUS_SUCCESS } from 'constants/statusConstants';
import Loading from 'components/fragments/Loading';
import Breadcrumb from 'components/fragments/Breadcrumb';
import CardPlayer from 'containers/fragments/card/CardPlayerContainer';
import Sidebar from 'components/sidebar/Sidebar';
import TeamPlayersFilters from 'components/team/TeamPlayersFilters';
import TeamMenuDropdownMenu from 'components/teammenu/TeamMenuDropdownMenu';
import { teamSubmenuHeaders } from 'constants/menuConstants';
import SubMenuHeader from 'components/header/SubMenuHeader';
//import { parionsSportLink } from 'constants/parionsSportsConstant';
import { getMetaBySlug } from 'utils/seoUtils';

export type StateProps = {
  title: string,
  excerpt: string,
  featured_media: {
    src: string,
    legend: string
  },
  sidebar_content: BlocContent[],
  joueursFetchStatus: Status,
  joueurs: JoueurType[],
  status: Status,
  seasons: SeasonListType[],
  searchedPlayer: string,
  defaultSeason: string,
  teamlist: TeamList[],
  redirect_competitions: string,
  redirect_resultats: string
};

export type DispatchProps = {
  fetchPageList: (slug: string) => void,
  fetchJoueursTeam: (filters: JoueurFiltersSearchType) => void,
  searchPlayer: (searchedPlayer: string) => void,
  initialFetchJoueursTeam: (filters: JoueurFiltersSearchType) => void,
  fetchTeamList: () => void,
  resetJoueur: () => void
};

type State = {
  seasonFilter: number | null,
  seasonMatches: string[],
  poste: number[],
  competitions: number[],
  playersFilters: JoueurFiltersSearchType,
  timestamp: any
};

type Props = {
  match: any,
  history: any,
  location: any
} & DispatchProps &
  StateProps;

class TeamPlayers extends Component<Props, State> {
  props: Props;
  state: State = {
    seasonFilter: null,
    seasonMatches: [],
    poste: [],
    competitions: [],
    playersFilters: {
      equipe: '',
      season: null,
      poste: [],
      competitions: []
    },
    timestamp: ''
  };

  componentDidMount() {
    const {
      match: {
        params: { slug }
      },
      initialFetchJoueursTeam,
      fetchPageList,
      searchPlayer,
      fetchTeamList,
      resetJoueur,
      seasons
    } = this.props;
    const filters = this.getFiltersOnQuery();

    initialFetchJoueursTeam({ ...filters, equipe: slug });
    fetchPageList(slug);
    searchPlayer('');
    fetchTeamList();
    resetJoueur();

    if (seasons && seasons.length) {
      this.getSeasonFilter();
    }

    this.setState({
      poste: filters.poste ? filters.poste : [],
      competitions: filters.competitions ? filters.competitions : [],
      playersFilters: filters
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const { defaultSeason, seasons } = this.props;
    //const { seasonFilter } = this.state;
    if (
      (seasons !== prevProps.seasons && seasons.length) ||
      (defaultSeason && defaultSeason !== prevProps.defaultSeason)
    ) {
      this.getSeasonFilter();
      //this.getCurrentSeasonCompetitions(seasonFilter);
    }

    //if (seasonFilter !== prevState.seasonFilter) {
    //this.getCurrentSeasonCompetitions(seasonFilter);
    //}
  }

  getSeasonFilter = () => {
    const {
      defaultSeason,
      location: { search },
      seasons
    } = this.props;

    let seasonFilter = 0;
    const params = new URLSearchParams(search);
    if (params && params.get('season')) {
      seasonFilter = parseInt(params.get('season'), 10);
    } else if (defaultSeason && seasons.length) {
      const saison = seasons.filter(season => {
        return season.name === defaultSeason;
      });
      seasonFilter = saison && saison.length > 0 ? saison[0].id : seasons[0].id;
    }

    const seasonMatches = this.getSeasonMatches(seasonFilter);

    this.setState({ seasonFilter, seasonMatches });
  };

  getCurrentSeasonCompetitions = currentSeasonId => {
    const { seasons } = this.props;

    const currentSeason = seasons.find(season => season.id === currentSeasonId);
    const competitions = currentSeason
      ? currentSeason.competitions.map(competition => parseInt(competition.value, 10))
      : [];

    this.setState({ competitions });
  };

  getSeasonMatches = (seasonFilter: number) => {
    const { seasons } = this.props;

    const currentSeason = seasons.find(season => season.id === seasonFilter);
    const seasonMatches = currentSeason ? currentSeason.rencontres : [];

    return seasonMatches;
  };

  _onFilterChange = (filters: JoueurFiltersSearchType, filterType: string) => {
    const { history, fetchJoueursTeam, defaultSeason, seasons } = this.props;

    if (!filters.season) {
      const saison = seasons.filter(season => {
        return season.name === defaultSeason;
      });
      filters.season = saison[0].id;
    } else {
      const seasonMatches = this.getSeasonMatches(filters.season);
      this.setState({ seasonFilter: filters.season, seasonMatches });
    }

    if (filterType && filterType === 'poste') {
      this.setState({ poste: filters.poste ? filters.poste : [], playersFilters: filters });
    } else if (filterType && filterType === 'competitions') {
      this.setState({ competitions: filters.competitions ? filters.competitions : [], playersFilters: filters });
    } else {
      this.setState({ poste: [], competitions: [], playersFilters: filters });
      filters.competitions = [];
      filters.poste = [];

      fetchJoueursTeam(filters);
    }

    history.replace({
      search: convertObjectToQueryString(filters)
    });
  };

  getFiltersOnQuery = () => {
    const {
      location: { search }
    } = this.props;
    if (search !== '') {
      return convertQueryStringToTeam(search);
    } else {
      return nullPlayersFiltersSearch;
    }
  };

  getPlayersWhoHavePlayedAtLeastOneMatch = (joueurs: JoueurType[]): JoueurType[] => {
    const { seasonMatches } = this.state;
    const playersWhoHavePlayed = joueurs.filter(joueur =>
      joueur.allMatches.some(match => seasonMatches.includes(match))
    );

    return playersWhoHavePlayed;
  };

  getPlayersByCompetitions = (joueurs: JoueurType[]): JoueurType[] => {
    const { playersFilters, competitions } = this.state;
    let competitionsFilters = competitions;
    if (playersFilters && playersFilters.competitions && playersFilters.competitions.length > 0) {
      competitionsFilters = playersFilters.competitions;
    }
    const filteredJoueurs = joueurs.filter(joueur => {
      if (joueur.competitions_jouees.length === 0) {
        return false;
      }
      let ok = false;
      joueur.competitions_jouees.forEach(comp => {
        if (competitionsFilters.includes(comp)) {
          ok = true;
        }
      });
      return ok;
    });

    return filteredJoueurs;
  };

  renderPlayersByPoste = (poste: Object) => {
    const { joueurs, searchedPlayer } = this.props;
    const { competitions } = this.state;
    const playersWhoHavePlayed = this.getPlayersWhoHavePlayedAtLeastOneMatch(joueurs);
    const restCards = playersWhoHavePlayed.length % 3;

    let filteredJoueurs = objectFilterTitle(playersWhoHavePlayed, searchedPlayer);
    if (competitions.length > 0) {
      filteredJoueurs = this.getPlayersByCompetitions(filteredJoueurs);
    }

    const filteredJoueursPoste = filteredJoueurs.filter(joueur => joueur.poste.name === poste);

    return filteredJoueursPoste.map((card, index) => {
      const isOnLastLine =
        (restCards === 0 && index >= playersWhoHavePlayed.length - 3) ||
        (restCards !== 0 && index >= playersWhoHavePlayed.length - restCards);

      const classNameContainer = dynamicClassName('col col-md-6 col-lg-4 mb-1 mb-md-3');
      isOnLastLine ? classNameContainer.add('mb-lg-0') : classNameContainer.add('mb-lg-4');
      if (card.poste.name === poste) {
        return (
          <div key={index} className={classNameContainer.build()}>
            <CardPlayer
              url={'joueurs/' + card.slug}
              title={card.title}
              poste={card.poste.name}
              featured_media={card.featured_media}
              noTextOverflow
            />
          </div>
        );
      } else {
        return false;
      }
    });
  };

  renderPlayersAll = () => {
    const { joueurs, searchedPlayer } = this.props;
    const { competitions } = this.state;
    const playersWhoHavePlayed = joueurs;
    //this.getPlayersWhoHavePlayedAtLeastOneMatch(joueurs);
    const restCards = playersWhoHavePlayed.length % 3;

    let filteredJoueurs = objectFilterTitle(playersWhoHavePlayed, searchedPlayer);
    if (competitions.length > 0) {
      filteredJoueurs = this.getPlayersByCompetitions(filteredJoueurs);
    }

    return filteredJoueurs.map((card, index) => {
      const isOnLastLine =
        (restCards === 0 && index >= playersWhoHavePlayed.length - 3) ||
        (restCards !== 0 && index >= playersWhoHavePlayed.length - restCards);

      const classNameContainer = dynamicClassName('col col-md-6 col-lg-4 mb-1 mb-md-3');
      isOnLastLine ? classNameContainer.add('mb-lg-0') : classNameContainer.add('mb-lg-4');
      return (
        <div key={index} className={classNameContainer.build()}>
          <CardPlayer
            url={'joueurs/' + card.slug}
            title={card.title}
            poste={card.poste.name}
            featured_media={card.featured_media}
            noTextOverflow
          />
        </div>
      );
    });
  };

  deleteCompetition = (id: number) => {
    const { playersFilters } = this.state;
    const competitionsFinales = playersFilters.competitions.filter(comp => comp !== id);
    playersFilters.competitions = competitionsFinales;
    this._onFilterChange(playersFilters, 'competitions');
  };

  deletePoste = (id: number) => {
    const { playersFilters } = this.state;
    const postesFinaux = playersFilters.poste.filter(poste => poste !== id);
    playersFilters.poste = postesFinaux;
    this._onFilterChange(playersFilters, 'poste');
  };

  renderFilters = () => {
    const { seasonFilter, playersFilters } = this.state;
    const { seasons, joueurs } = this.props;
    const season = seasons.filter(saison => saison.id === seasonFilter);
    let competitionsSaison = [];
    let postesSaison = [];

    if (season.length > 0 && playersFilters.competitions.length > 0) {
      const saison = season[0];
      competitionsSaison = saison.competitions.filter(comp => playersFilters.competitions.includes(comp.value));
    }

    if (playersFilters.poste.length > 0) {
      joueurs.forEach(joueur => {
        const isObjectPosteExists = postesSaison.findIndex(poste => poste.name === joueur.poste.name);
        if (playersFilters.poste.includes(joueur.poste.id) && isObjectPosteExists === -1) {
          postesSaison.push(joueur.poste);
        }
      });
    }

    return (
      <>
        {postesSaison.length > 0 && (
          <div className="mb-4">
            <p>
              <strong>{postesSaison.length > 1 ? 'Postes sélectionnés : ' : 'Poste sélectionné : '}</strong>
            </p>
            <ul className="list-label mb-2">
              {postesSaison.map(poste => {
                return (
                  <li key={`poste_${poste.id}`}>
                    <button
                      className="label label--rounded label--khaki"
                      title={`Supprimer ce filtre`}
                      onClick={() => this.deletePoste(parseInt(poste.id, 10))}
                    >
                      {poste.name} <i className="icon icon-delete" />
                    </button>
                  </li>
                );
              })}
            </ul>
          </div>
        )}
        {competitionsSaison.length > 0 && (
          <div className="mb-4">
            <p>
              <strong>
                {competitionsSaison.length > 1 ? 'Compétitions sélectionnées : ' : 'Compétition sélectionnée : '}
              </strong>
            </p>
            <ul className="list-label mb-2">
              {competitionsSaison.map(competition => {
                return (
                  <li key={`competition_${competition.value}`}>
                    <button
                      className="label label--rounded label--khaki"
                      title={`Supprimer ce filtre`}
                      onClick={() => this.deleteCompetition(parseInt(competition.value, 10))}
                    >
                      {competition.label} <i className="icon icon-delete" />
                    </button>
                  </li>
                );
              })}
            </ul>
          </div>
        )}
      </>
    );
  };

  renderCards = () => {
    const { joueurs, searchedPlayer, joueursFetchStatus, title } = this.props;
    const { playersFilters } = this.state;
    if (joueursFetchStatus === STATUS_LOADING) {
      return <Loading isWhite />;
    }

    if (joueursFetchStatus !== STATUS_LOADING && joueurs && joueurs.length > 0) {
      let playersWhoHavePlayed = joueurs;
      if (!title.match('7')) {
        playersWhoHavePlayed = this.getPlayersWhoHavePlayedAtLeastOneMatch(joueurs);
      }

      let filteredJoueurs = objectFilterTitle(playersWhoHavePlayed, searchedPlayer);
      // si il y a des compétitions
      if (playersFilters && playersFilters.competitions.length > 0) {
        filteredJoueurs = this.getPlayersByCompetitions(filteredJoueurs);
      }

      // si on n'a pas de joueurs => empty state
      if (filteredJoueurs.length === 0) {
        return (
          <div className="placeholder col col-lg-8on9">
            <p className="ft-h5">
              <i className="icon"></i>Aucun résultat pour cette recherche
            </p>
          </div>
        );
      }

      // rendu pour tous
      if (title.match('7')) {
        return (
          <div className="row mb-4">
            <div className="players-list">
              <div className="row">
                <div className="col col-lg-8on9">{this.renderPlayersAll()}</div>
              </div>
            </div>
          </div>
        );
      }

      // rendu par postes
      let postes: any[] = [];
      filteredJoueurs.forEach(joueur => {
        const isObjectPosteExists = postes.findIndex(poste => poste.name === joueur.poste.name);
        if (isObjectPosteExists === -1) postes.push(joueur.poste);
      });
      postes = postes
        .sort((a, b) => {
          return a.ordre - b.ordre;
        })
        .map(poste => ({ value: poste.id, label: poste.name, ordre: poste.ordre }));
      if (this.state.poste && this.state.poste.length > 0) {
        postes = postes.filter(poste => {
          return this.state.poste.indexOf(poste.value) !== -1;
        });
      }
      return postes.sort().map((poste, index) => {
        return (
          <div key={'poste_' + index} className="row mb-4">
            <div className="players-list">
              <div className="col col-lg-8on9">
                <h3 className="mb-3">{poste.label}</h3>
              </div>
              <div className="row">
                <div className="col col-lg-8on9">{this.renderPlayersByPoste(poste.label)}</div>
              </div>
            </div>
          </div>
        );
      });
    } else {
      return null;
    }
  };

  teamChange(team: Object) {
    this.props.history.push(team.link);
  }

  render() {
    const {
      title,
      excerpt,
      status,
      featured_media,
      sidebar_content,
      joueurs,
      searchPlayer,
      seasons,
      defaultSeason,
      teamlist,
      redirect_competitions,
      redirect_resultats
    } = this.props;
    const { typeRugby, slug } = this.props.match.params;
    const { seasonFilter, playersFilters } = this.state;
    const genre = joueurs.length > 0 ? joueurs[0].genre : 'M';

    if (status === STATUS_LOADING) {
      return <Loading isBlue backgroundColor={'#013974'} />;
    }

    let selectedTeam = false;
    if (teamlist && teamlist.length > 0) {
      selectedTeam = teamlist.filter((team, index) => {
        return team.title === title;
      });
    }

    if (redirect_competitions) {
      teamSubmenuHeaders[3].type_name = 'external';
      teamSubmenuHeaders[3].object_slug = redirect_competitions;
    }

    if (redirect_resultats) {
      teamSubmenuHeaders[2].type_name = 'external';
      teamSubmenuHeaders[2].object_slug = redirect_resultats;
    }

    if (this.props.match.params.slug === 'xv-de-france') {
      teamSubmenuHeaders[7] = {
        menu_order: 35,
        object_slug: '/le-grand-soutien',
        title: 'Le grand soutien',
        description: '',
        featured_media: { src: '' },
        texte_cta: '',
        object_id: 0,
        type_name: 'external'
      };
    }

    /*if (this.props.match.params.slug === 'xv-de-france-masculin') {
      teamSubmenuHeaders[7] = {
        menu_order: 40,
        object_slug: parionsSportLink,
        title: 'Parions Sport',
        description: '',
        featured_media: { src: '' },
        texte_cta: '',
        object_id: 0,
        type_name: 'external'
      };
    }*/

    return (
      <>
        <section className="banner">
          <div className="banner__thumbnail img-blue-dark" style={{ backgroundImage: `url(${featured_media.src})` }} />
          <div className="container">
            <Breadcrumb
              elements={[
                { name: 'accueil', to: '/' },
                { name: 'Équipes de France', to: '/equipe-de-france' },
                { name: title, to: '/equipe-de-france/' + typeRugby + '/' + slug },
                `L'équipe`
              ]}
              isDark
            />
            {teamlist && teamlist.length > 0 && selectedTeam && selectedTeam.length > 0 && (
              <TeamMenuDropdownMenu
                hiddenMenuElements={teamlist}
                isMobile={false}
                id={6}
                level={'h1'}
                activeTeam={selectedTeam[0]}
                switchTeam={this.teamChange.bind(this)}
              />
            )}
            {(!teamlist || teamlist.length === 0) && <h1 className="ft-h2">{title}</h1>}
            {excerpt && <p className="banner__desc">{excerpt}</p>}
          </div>
          <SubMenuHeader
            subMenus={teamSubmenuHeaders}
            subMenuPath={'/equipe-de-france/' + typeRugby + '/' + slug}
            status={STATUS_SUCCESS}
            niveauMenu={4}
          />
        </section>

        <div className="container">
          <div className="row">
            <div className="col col-md-8 col-lg-9 bg-overflow">
              <section>
                <TeamPlayersFilters
                  joueurs={this.getPlayersWhoHavePlayedAtLeastOneMatch(joueurs)}
                  slug={slug}
                  seasons={seasons}
                  seasonFilter={seasonFilter}
                  defaultSeason={defaultSeason}
                  searchPlayer={searchPlayer}
                  title={title}
                  genre={genre}
                  onFilterChange={(filters, filterType) => this._onFilterChange(filters, filterType)}
                  initialFilters={playersFilters}
                />
                {this.renderFilters()}
                {this.renderCards()}
              </section>
            </div>
            <Sidebar sidebarContent={sidebar_content} />
          </div>
        </div>
      </>
    );
  }
}

export default withHelmet(withRouter(TeamPlayers))((Helmet, pageProps) => {
  const {
    title,
    match: { params, url }
  } = pageProps;
  const meta = getMetaBySlug(url, params);
  const ogimage = pageProps.featured_media ? pageProps.featured_media.src : false;
  const ogimagetitle = pageProps.featured_media ? pageProps.featured_media.title : false;
  return (
    <Helmet>
      <title>{meta.title(title)}</title>
      <meta name={'description'} content={meta.description(title)} />
      <meta property={'og:url'} content={window.location.href} />
      <meta property={'og:title'} content={meta.title(title)} />
      <meta property={'og:description'} content={meta.description(title)} />
      {ogimage && <meta property={'og:image'} content={ogimage} />}
      {ogimage && <meta property={'og:image:url'} content={ogimage} />}
      {ogimage && ogimagetitle && <meta property={'og:image:title'} content={ogimagetitle} />}
      <link rel={'canonical'} href={window.location.href} />
    </Helmet>
  );
});
